import React, { FC, RefObject } from 'react';
import {
  Modal,
  CustomModalLayout,
  Layout,
  Box,
  Cell,
  SkeletonGroup,
  SkeletonRectangle,
  SkeletonLine,
} from '@wix/design-system';
import { dataHooks } from './constants';

interface Props {
  isModalOpen: boolean;
  parentRef?: RefObject<HTMLDivElement>;
  openHelpCenter: () => void;
  onCloseButtonClick: () => void;
  primaryButtonText: string;
  secondaryButtonText: string;
  secondaryButtonOnClick: () => void;
}

export const LoadingState: FC<Props> = ({
  isModalOpen,
  parentRef,
  openHelpCenter,
  onCloseButtonClick,
  primaryButtonText,
  secondaryButtonText,
  secondaryButtonOnClick,
}) => (
  <SkeletonGroup>
    <Modal
      dataHook={dataHooks.modalLayout}
      isOpen={isModalOpen}
      parentSelector={() => parentRef?.current || document.body}
    >
      <CustomModalLayout
        dataHook={dataHooks.customModalLayout}
        width="600px"
        height="201px"
        theme="destructive"
        onHelpButtonClick={openHelpCenter}
        onCloseButtonClick={onCloseButtonClick}
        title={
          <Layout alignItems="center" gap="SP2">
            <Cell span={1}>
              <SkeletonRectangle
                width="30px"
                height="30px"
                dataHook={dataHooks.avatarLoader}
              />
            </Cell>
            <Cell span={11}>
              <SkeletonRectangle
                width="444px"
                height="30px"
                dataHook={dataHooks.headingTitleLoader}
              />
            </Cell>
          </Layout>
        }
        content={
          <Box
            direction="vertical"
            gap="SP2"
            dataHook={dataHooks.contentLoader}
          >
            <SkeletonLine width="552px" />
            <SkeletonLine width="276px" />
          </Box>
        }
        primaryButtonText={primaryButtonText}
        primaryButtonProps={{ disabled: true }}
        secondaryButtonText={secondaryButtonText}
        secondaryButtonOnClick={secondaryButtonOnClick}
      />
    </Modal>
  </SkeletonGroup>
);
